<template>
  <div class="about-container">
    <!-- SECCIÓN ÚNICA SOBRE MÍ - OSCURA -->
    <section class="about-unified dark-section">
      <p class="display-2 section-title">Sobre mí</p>
      <div class="unified-content">
        <img
          src="../assets/images/Yo.jpg"

          class="profile-img"
             alt="Leonardo Rios desarrollador fronted"
        />
        <div class="unified-text">
          <h1 class="name">Leonardo Rios López</h1>
          <h2 class="role">Desarrollador Frontend</h2>
          <p class="description">
            Soy un joven apasionado por la tecnología y la informática. Desde
            muy temprana edad me llamó la atención este mundo y la programación,
            siendo mi punto de partida la frase
            <em>"si puedes pensarlo, puedes programarlo"</em>. Durante casi 5
            años he aprendido programación de manera independiente, enfocándome
            en desarrollo web, con planes de expandirme al desarrollo de apps
            Android e iOS. Próximamente iniciaré mi carrera en ingeniería en
            sistemas.
          </p>
        </div>
      </div>
    </section>

    <!-- SECCIÓN HABILIDADES - CLARA (SE MANTIENE IGUAL) -->
    <section class="skills light-section">
      <h2 class="skills-title">Habilidades</h2>
      <div class="skills-grid">
        <div class="skill-card">
          <h3>Lenguajes y Frameworks</h3>
          <p>
            ● Vue.js <br />
            ● JavaScript <br />
            ● TypeScript <br />
            ● HTML5 <br />
            ● CSS3 <br />
            ● Bootstrap
          </p>
        </div>
        <div class="skill-card">
          <h3>Herramientas</h3>
          <p>
            ● npm <br />
            ● Vue-CLI <br />
            ● Vue Router<br />
            ● GitHub <br />
            ● Cloudflare Pages
          </p>
        </div>
        <div class="skill-card">
          <h3>Personal</h3>
          <p>
            ● Inglés A2-B1<br />
            ● Responsabilidad y disposición<br />
            ● Aprendizaje continuo<br />
            ● Trabajo en equipo<br />
            ● Puntualidad<br />
            ● Conocimientos básicos en edición y Linux
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );
  const elements = document.querySelectorAll('.animate-on-scroll');
  elements.forEach((el) => observer.observe(el));
});
</script>

<style scoped>
.about-container {
  font-family: "Arial", sans-serif;
  width: 100%;
  margin-top: 0; /* QUITADO: se elimina el margen superior */
}

/* SECCIÓN SOBRE MÍ - OSCURA (100% VIEWPORT SIN ESPACIO ARRIBA) */
.dark-section {
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  padding: 0 20px; /* QUITADO: padding-top y bottom */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Centra verticalmente */
  align-items: center;
}

/* SECCIÓN HABILIDADES - CLARA (SE MANTIENE IGUAL) */
.light-section {
  color: var(--color-surface) !important;
  padding: 80px 20px; /* Este mantiene su padding */
}

/* SECCIÓN UNIFICADA SOBRE MÍ */
.about-unified {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.section-title {
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 60px;
  color: var(--color-text-primary);
  text-align: center;
}

.unified-content {
  display: flex;
  align-items: center;
  gap: 50px;
  max-width: 1000px;
  width: 100%;
  justify-content: center;
}

.profile-img {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  border: 4px solid var(--color-primary);
  object-fit: cover;
  flex-shrink: 0;
}

.unified-text {
  flex: 1;
  text-align: left;
}

.name {
  font-size: 2.5rem;
  margin: 0 0 10px 0;
  color: var(--color-text-primary);
}

.role {
  font-size: 1.4rem;
  color: var(--color-primary);
  margin: 0 0 30px 0;
  font-weight: 400;
}

.description {
  line-height: 1.7;
  font-size: 1.1rem;
  margin: 0;
  text-align: justify;
  color: var(--color-text-primary);
}

.description em {
  color: var(--color-primary-light);
  font-style: italic;
}

/* SECCIÓN HABILIDADES (SE MANTIENE IGUAL) */
.skills-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 60px;
  color: var(--color-surface) !important;

  text-align: center;
}

.skills-grid {
  display: flex;
  gap: 0;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
}

.skill-card {
  border-radius: 12px;
  padding: 30px 25px;
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  position: relative;
}

/* RAYITAS VERTICALES ENTRE COLUMNAS */
.skill-card:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 20%;
  height: 60%;
  width: 1px;
  background: var(--color-surface);
}

.skill-card h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: var(--color-surface) !important;
  font-size: 1.3rem;
  text-align: center;
}

.skill-card p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.8;
  text-align: left;
  color: var(--color-surface) !important;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  /* Solo ajustes para la primera sección en móvil */
  .dark-section {
    padding: 0 20px;
    min-height: 100vh;
  }

  .section-title {
    font-size: 2.5rem;
    margin-bottom: 40px;
  }

  .unified-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 30px;
  }

  .unified-text {
    text-align: center;
  }

  .profile-img {
    width: 180px;
    height: 180px;
  }

  .name {
    font-size: 2rem;
  }

  .role {
    font-size: 1.2rem;
  }

  .description {
    text-align: center;
  }

  /* Habilidades se mantiene igual en responsive */
  .skills-grid {
    flex-direction: column;
    gap: 20px;
  }

  .skill-card {
    max-width: 100%;
  }

  .skill-card:not(:last-child)::after {
    display: none;
  }

  .skill-card:not(:last-child)::before {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 10%;
    width: 80%;
    height: 1px;
    background: var(--color-surface);
  }
}

@media (max-width: 480px) {
  .dark-section {
    padding: 0 15px;
    min-height: 100vh;
  }

  .section-title {
    font-size: 2rem;
  }

  .name {
    font-size: 1.8rem;
  }

  .profile-img {
    width: 150px;
    height: 150px;
  }
}
</style>
